import React, { useState } from "react";
import { makeStyles, createStyles, Checkbox, Link } from "@material-ui/core";
import { ITheme } from "../../Layout/themes";
import { IStoreState } from "../../Store";
import { ThunkDispatch } from "redux-thunk";
import { updateCheckReceive } from "./actions";
import { connect } from "react-redux";
import { IEnvironment } from "../../../interface/IShareInfo";

const useStyles = makeStyles(({ palette }: ITheme) => {
  return createStyles({
    checkboxBox: {
      marginTop: "-7px",
      "& svg": {
        fontSize: 20
      }
    },
    checkboxLabel: {
      color: palette.text.secondary,
      fontSize: "1.2rem",
      lineHeight: 1
    },
    checkLineContainer: {
      display: "flex",
      margin: 20
    },
    checkboxContainer: {
      width: 38,
      marginLeft: -10
    },
    checkLineText: {
      paddingRight: 5,
    }
  });
});

interface ILegalInfoProps {
  checkReceive: boolean;
  updateCheckReceive: (checkStatus: boolean) => void;
  env: IEnvironment;
}

export const LegalInfoComponent = ({
  checkReceive,
  updateCheckReceive,
  env
}: ILegalInfoProps) => {
  const classes = useStyles({});
 

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateCheckReceive(!checkReceive);
  };

  return (
    <React.Fragment>
      <div className={classes.checkLineContainer}>
        <div className={classes.checkboxContainer}>
          <Checkbox
            checked={checkReceive}
            onChange={handleChange}
            classes={{
              root: classes.checkboxBox
            }}
          />
        </div>
        <div className={classes.checkboxLabel}>
          <span className={classes.checkLineText}>
            I would like to receive information regarding events directly from
            the venue and event organisers.
          </span>
          <Link
            href={env.PRIVACY_POLICY_URL}
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </Link>
          .
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state: IStoreState) => {
  return {
    checkReceive: state.ticketReceiveData.checkReceive,
    env: state.env
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
  return {
    updateCheckReceive: (checkStatus: boolean) =>
      dispatch(updateCheckReceive(checkStatus))
  };
};

export const LegalInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(LegalInfoComponent);
